import instoreOfferModalSaga from './instoreOfferModal';

export default instoreOfferModalSaga;
